import { CONSTANTS } from "./constants";
export const FormFields = {
  GO_PAPPERLESS_AGREEMENT: {
    type: "radio",
    id: "go-papperless-agreement",
    name: "goPaperlessAgreement",
    labelId: "go-papperless",
    Options: CONSTANTS.agrrementButtons,
    selected: "true",
    title: "Choose paperless delivery?",
    formsControlId: "checkbox-forms-id-1",
    ariaDescribedBy: "go-paperless",
    validation: {
      required: {
        message: "Please acknowledge to continue",
      },
    },
  },
};
